
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17 22C18.66 22 20 20.66 20 19C20 17.34 18.66 16 17 16C15.7 16 14.6 16.84 14.18 18H9.14004L11.13 14.94C11.42 14.98 11.71 15 12 15C12.29 15 12.58 14.98 12.87 14.94L13.89 16.51C14.31 15.98 14.85 15.56 15.49 15.3L14.89 14.37C16.99 13.42 18.53 11.47 18.91 9.13C19.01 8.54 18.52 8 17.92 8C15.31 8 8.69004 8 6.08004 8C5.48004 8 4.99004 8.54 5.09004 9.14C5.47004 11.48 7.02004 13.43 9.11004 14.38L5.16004 20.46C4.86004 20.92 4.99004 21.54 5.45004 21.84C5.91004 22.14 6.53004 22.01 6.83004 21.55L7.83004 20H14.17C14.6 21.16 15.7 22 17 22ZM17 18C17.55 18 18 18.45 18 19C18 19.55 17.55 20 17 20C16.45 20 16 19.55 16 19C16 18.45 16.45 18 17 18Z' fill='#323232'/><path d='M9.50026 6.47C9.48026 6.75 9.68026 7 9.96026 7H10.0003C10.2403 7 10.4403 6.82 10.4603 6.58C10.5603 5.71 10.5003 5.19 9.52026 4.04C9.16026 3.61 8.92026 3.35 8.99026 2.49C9.02026 2.23 8.80026 2 8.53026 2H8.48026C8.24026 2 8.03026 2.19 8.01026 2.43C7.93026 3.36 8.21026 4.17 8.96026 4.96C9.15026 5.17 9.60026 5.52 9.50026 6.47Z' fill='#323232'/><path d='M11.9902 6.47C11.9602 6.75 12.1702 7 12.4502 7H12.4802C12.7202 7 12.9202 6.82 12.9402 6.58C13.0402 5.71 12.9802 5.19 12.0002 4.04C11.6402 3.61 11.3902 3.35 11.4702 2.49C11.5002 2.23 11.2802 2 11.0102 2H10.9602C10.7202 2 10.5102 2.19 10.4902 2.43C10.4102 3.36 10.6902 4.17 11.4402 4.96C11.6302 5.17 12.0802 5.52 11.9902 6.47Z' fill='#323232'/><path d='M14.5003 6.47C14.4803 6.75 14.6803 7 14.9603 7H15.0003C15.2403 7 15.4403 6.82 15.4603 6.58C15.5603 5.71 15.5003 5.19 14.5203 4.04C14.1603 3.61 13.9103 3.35 13.9903 2.49C14.0203 2.23 13.8003 2 13.5303 2H13.4803C13.2403 2 13.0303 2.19 13.0103 2.43C12.9303 3.36 13.2103 4.17 13.9603 4.96C14.1503 5.17 14.6003 5.52 14.5003 6.47Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-outdoor-grill`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconOutdoorGrill

    ```js
    <b-new-b-icon-outdoor-grill />
    ```
</docs>


